import React, { FC, memo, useCallback } from "react";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { OpenRightPanel } from "types/common/rightPanel";
import { openRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import {
  panelSelectData,
  panelSelectOpened,
} from "../../../../reduxFolder/selectors/rightPanelSelectors";
import { useFormattedDate } from "../../../../utils/formatDate";
import {
  ContainerCol,
  ContainersListRow,
  ParcelDate,
  Sku,
  WeightText,
} from "./ContainerRow.styles";

interface ContainerRowProps {
  container: any;
  units: string;
  panelData: any;
  isPanelOpened: boolean;
  openRightPanel: OpenRightPanel;
}

const ContainerRow: FC<ContainerRowProps> = ({
  container,
  units,
  openRightPanel,
  isPanelOpened,
  panelData,
}) => {
  const { t } = useTranslation("common");
  const containerId = container.get("id");
  const sku = container.get("sku");
  const state = container.get("state");
  const weight = container.get("weight");
  const containerDate = useFormattedDate({
    date: container.get("created_at", new Date()),
    hideCurrentYearDisplay: true,
  });

  const isSelected =
    isPanelOpened &&
    panelData &&
    panelData.get("containerId") === containerId;

  const handleClick = useCallback(
    () => openRightPanel("CONTAINER_DETAILED", Map({ containerId, sku })),
    [openRightPanel, containerId, sku],
  );

  return (
    <ContainersListRow
      align={"center"}
      selected={isSelected}
      onClick={handleClick}
    >
      <ContainerCol xs={2} lg={1}>
        <Sku>{sku}</Sku>
      </ContainerCol>
      <ContainerCol xs={2} lg={3}>
        {t(`containers.state.${state}`)}
      </ContainerCol>
      <ContainerCol xs={3} lg={3}>
        {container.get("width")} x {container.get("height")} x{" "}
        {container.get("length")} {t(`units.${units}.secondaryShort`)}
      </ContainerCol>
      <ContainerCol xs={2} lg={2}>
        <WeightText>
          {weight != null
            ? `${Number(weight).toFixed(2)} ${t(`units.${units}.primaryShort`)}`
            : "—"}
        </WeightText>
      </ContainerCol>
      <ContainerCol xs={3} lg={3}>
        <ParcelDate>{containerDate}</ParcelDate>
      </ContainerCol>
    </ContainersListRow>
  );
};

const withConnect = connect(
  createStructuredSelector({
    isPanelOpened: panelSelectOpened,
    panelData: panelSelectData,
  }),
  { openRightPanel },
);

export default compose(withConnect, memo)(ContainerRow) as any;
